import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, MapPinIcon } from 'lucide-react';
import { permitStatusLabels, permitStatusOrder, type PermitStatus } from '../../data/permis';
import { usePermits } from '../../contexts/PermitsContext';
export function PermitProgress({
  status
}: {
  status: PermitStatus;
}) {
  const currentIndex = permitStatusOrder.indexOf(status);
  return <ol className="flex items-center gap-2" aria-label={`Statut : ${permitStatusLabels[status]}`} data-id="element-2411" data-mp="xww7obsmpnyj">
      {permitStatusOrder.map((step, index) => {
      const reached = index <= currentIndex;
      return <li key={step} className="flex items-center gap-2" data-id="element-2412" data-mp="17lxp86etodem" data-mpi={index}>
            <span className={`rounded-full px-3 py-1 text-xs font-bold ${index === currentIndex ? 'bg-ville-indigo text-white' : reached ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-100 text-slate-400'}`} data-id="element-2413" data-mp="1clajhc80wmr8">
              {permitStatusLabels[step]}
            </span>
            {index < permitStatusOrder.length - 1 && <span className={`h-0.5 w-5 rounded-full ${index < currentIndex ? 'bg-ville-indigo' : 'bg-slate-200'}`} aria-hidden="true" data-id="element-2414" data-mp="it78mwnnrgzn" />}
          </li>;
    })}
    </ol>;
}
export function PermisList() {
  const {
    permits
  } = usePermits();
  return <section aria-labelledby="mes-permis-titre" data-id="element-2415" data-mp="16lw3z07fkgao">
      <h2 id="mes-permis-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2416" data-mp="11m1gl6mv68ud">
        Mes demandes de permis
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-2417" data-mp="ws716feakg13">Suivez l’analyse de vos dossiers d’urbanisme.</p>

      <ul className="mt-6 space-y-3" data-id="element-2418" data-mp="rtcgt90oejev">
        {permits.map(permit => {
        const pending = permit.documents.filter(document => !document.received).length;
        return <li key={permit.id} data-id="element-2419" data-mp="1khrheqj28z6o">
              <Link to={`/mes-permis/${permit.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2420" data-mp="3erydv1f7qlx6">
                <div className="min-w-0 flex-1" data-id="element-2421" data-mp="39zezi28pbmrb">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-2422" data-mp="2v3yytedm8sly">
                    <h3 className="text-[15px] font-extrabold text-ville-navy" data-id="element-2423" data-mp="2v5tjqsow0kq1">{permit.title}</h3>
                    <span className="text-xs font-semibold text-slate-400" data-id="element-2424" data-mp="300pi0akpw4bl">{permit.reference}</span>
                    {permit.feeStatus === 'a-payer' ? <span className="rounded-full bg-ville-lime px-2.5 py-0.5 text-[11px] font-bold text-ville-navy" data-id="element-2425" data-mp="2r35awl06bdt2">
                        Frais de {permit.fee} à payer
                      </span> : pending > 0 && <span className="rounded-full bg-ville-lime px-2.5 py-0.5 text-[11px] font-bold text-ville-navy" data-id="element-2426" data-mp="zefo5zj1vd4y">
                          {pending} document{pending > 1 ? 's' : ''} manquant{pending > 1 ? 's' : ''}
                        </span>}
                  </div>
                  <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-2427" data-mp="13f81b3v1m26i">
                    <span className="flex items-center gap-1.5" data-id="element-2428" data-mp="1i443ikaf4kz7">
                      <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-2429" data-mp="1d6cdxwx8xay6" />
                      {permit.address}
                    </span>
                    <span data-id="element-2430" data-mp="1r4ka42mgk88a">{permit.submittedOn}</span>
                  </p>
                  <div className="mt-3" data-id="element-2431" data-mp="1n40b0tibquji">
                    <PermitProgress status={permit.status} data-id="element-2432" data-mp="1n51lowvfhf0p" />
                  </div>
                </div>
                <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-2433" data-mp="3szb26soiqir7" />
              </Link>
            </li>;
      })}
      </ul>
    </section>;
}